import { Component, ElementRef, Input, SimpleChanges, ViewChild } from '@angular/core';
import { DashboardAlarmsRequest } from '../../model/DashboardAlarmsRequest';
import { ControlPanelService } from '../../services/ControlPanel.service';
import { MainDashboardResumeDTO } from '../../model/MainDashboardResumeDTO';
import { Chart, ChartData, ChartType } from 'chart.js';
import { EnumAlarmCategoriesValues, EnumAlarmCategory } from 'src/app/features/shared/helpers/enums/EnumAlarmCategories';

@Component({
  selector: 'alerts-card',
  templateUrl: './alerts-card.component.html',
  styleUrls: ['./alerts-card.component.css']
})
export class AlertsCardComponent {
  // @ViewChild('alertChart', { static: false }) canvasRef: ElementRef<HTMLCanvasElement>;
   

  @Input() dashboardAlarms: DashboardAlarmsRequest[] = [];
  isLoading: boolean = false;

  chartColors: any[] = [
    {backgroundColor: 'rgba(75, 192, 192, 0.5)', borderColor: 'rgba(75, 192, 192, 1)'},
    {backgroundColor: 'rgba(153, 102, 255, 0.5)', borderColor: 'rgba(153, 102, 255, 1)'},
    {backgroundColor: 'rgba(255, 159, 64, 0.5)', borderColor: 'rgba(255, 159, 64, 1)'},
    {backgroundColor: 'rgba(255, 99, 132, 0.5)', borderColor: 'rgba(255, 99, 132, 1)'},
    {backgroundColor: 'rgba(54, 162, 235, 0.5)', borderColor: 'rgba(54, 162, 235, 1)'},
    {backgroundColor: 'rgba(255, 206, 86, 0.5)', borderColor: 'rgba(255, 206, 86, 1)'},
    {backgroundColor: 'rgba(201, 203, 207, 0.5)', borderColor: 'rgba(201, 203, 207, 1)'},
  ];

  options= {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { 
        position: 'top',
        labels: {
          boxWidth: 10,
          padding: 5  
        },
      }
    }
  }

  pieChartLabels: string[] = [];
  pieChartData = {
    labels: [],
    datasets: [],
  };

  chartWithStyle : any;

  constructor(private controlPanelService: ControlPanelService) { 

  }

  ngAfterViewInit(): void {
    this.isLoading = true;
    const uniqueAlarms = this.getUniqueAlarms(this.dashboardAlarms);
    this.pieChartLabels = this.getAlarmCategoryNames(uniqueAlarms);
    this.pieChartData = {
      labels: this.pieChartLabels,
      datasets: [
        {
          data: uniqueAlarms.map(item => item.totalActivesByCategory),
          backgroundColor: this.chartColors.map(color => color.borderColor),
        },
      ],
    };
    
    // const canvasContext = this.canvasRef?.nativeElement.getContext('2d');
    // if (canvasContext) {
    //   this.chartWithStyle = new Chart(canvasContext, {
    //     type: 'pie',
    //     data: {
    //       labels: this.pieChartData.labels,
    //       datasets: [
    //         {
    //           data: this.pieChartData.datasets[0].data,
    //           backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0'],
    //           borderWidth: 1,
    //           borderColor: '#fff',
              
    //         }
    //       ],

    //     },
        
    //   });
    // }
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dashboardAlarms'] && this.dashboardAlarms) {
      const uniqueAlarms = this.getUniqueAlarms(this.dashboardAlarms);
      this.pieChartLabels = this.getAlarmCategoryNames(uniqueAlarms);
      this.pieChartData = {
        labels: this.pieChartLabels,
        datasets: [
          {
            data: uniqueAlarms.map(item => item.totalActivesByCategory),
            backgroundColor: this.chartColors.map(color => color.borderColor),
          },
        ],
      };
      this.isLoading = false;
    }else{
      this.isLoading = false;
    }
  }

  getUniqueAlarms(alarms: DashboardAlarmsRequest[]){
    const map = new Map<string, DashboardAlarmsRequest>();
    alarms.forEach(alarm => {
      if (!map.has(alarm.categoryName)) {
        map.set(alarm.categoryName, alarm);
      }
    });
    return Array.from(map.values());
  }

  getAlarmCategoryNames(uniqueAlarms: DashboardAlarmsRequest[]): string[] {
    var names = [];
    uniqueAlarms.forEach(alarm => {
      var nameEnumKey =Object.keys(EnumAlarmCategoriesValues).find( key => key == alarm.categoryName);
      console.log("nameEnumKey", nameEnumKey, EnumAlarmCategoriesValues, alarm.categoryName);
      
      if(nameEnumKey){
        const name = EnumAlarmCategoriesValues[nameEnumKey];
        names.push(name);
      }
    });
    return names;
  }

}
